export default __webpack_public_path__ + "static/media/CNo.37-1.b9c5bc79.jpg";